module.exports = __webpack_public_path__ + "img/005-google.02d31de0.svg";